import React from 'react';
/**
 * Tag 컴포넌트 - 프로젝트 태그를 표시합니다.
 * 
 * 아토믹 디자인의 원자(Atom) 레벨 컴포넌트
 */ var Tag = function(param) {
    var text = param.text, _param_className = param.className, className = _param_className === void 0 ? '' : _param_className;
    return /*#__PURE__*/ React.createElement("span", {
        className: "text-xs bg-gray-100 dark:bg-gray-800 text-gray-700 dark:text-gray-300 px-2 py-1 rounded-full ".concat(className)
    }, "#", text);
};
export default Tag;
